export default "__VITE_ASSET__BvA0l10H__"